import * as React from "react";
import { Text, ScrollView, View } from "react-native";

export default () => {
  return <View></View>;
};
